import { Component } from '@angular/core';

import { GridPanelComponent } from '../grid-panel/grid-panel.component';

@Component({
    selector: 'aa-grid-simple-panel',
    templateUrl: './grid-simple-panel.component.html',
    styleUrls: [
        '../grid-container.constants.scss'
    ],
    standalone: false
})
export class GridSimplePanelComponent extends GridPanelComponent
{
}
